<template>
  <v-overlay :value="loading" style="z-index:1000">
    <v-progress-circular :size="70" :width="4" color="primary" indeterminate></v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("general", ["loading"])
  },
  components: {}
};
</script>